import type { ContainerInset } from './';
import type { BoxProps } from '@withjoy/joykit';

export const CARD_MEDIA_BACKGROUND_PLACEMENT = {
  center: 'center',
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right'
} as const;

export const ELEVATION_LIGHTING = {
  0: {
    default: '',
    hover: '',
    active: ''
  },
  1: {
    default: '0px 6px 24px rgba(44, 41, 37, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.07)',
    hover: '0px 10px 27px rgba(44, 41, 37, 0.25), 0px 7px 16px rgba(0, 0, 0, 0.3)',
    active: '0px 2px 5px rgba(44, 41, 37, 0.25), 0px 1px 3px rgba(0, 0, 0, 0.3)'
  }
} as const;

export const CONTAINER_INSET_RULES: ReadonlyRecord<ContainerInset, Pick<BoxProps, 'padding' | 'paddingX' | 'paddingY'>> = {
  md: {
    padding: 6
  },
  md1: {
    padding: 7
  }
};
